import {NumberBox} from "devextreme-react";
import {Controller, useFormContext, useFormState} from "react-hook-form";
import React, {useEffect} from "react";
import {on} from "events";

interface IProps {
    title?: string;
    isValid?: boolean;
    validationMessage?: string;
    fieldName: string;
    required?: boolean;
    showBorder?: boolean;
    width?: number;
    index?: number;
    onValueChanged?: (e: number, index: number) => void;
    value?: number;
    min?: number;
    max?: number;
}

export const NFIntInput = ({
                               title,
                               isValid,
                               validationMessage,
                               fieldName,
                               showBorder = true,
                               required,
                               width,
                               index = 0,
                               onValueChanged,
                               min,
                               max,
                               value,
                           }: IProps) => {
    const {register, control, setValue} = useFormContext();
    const {errors, dirtyFields} = useFormState();

    useEffect(() => {
        if (value !== undefined) {
            setValue(fieldName, value);
        }
    }, [value]);

    return (
        <Controller
            control={control}
            name={fieldName}
            defaultValue={0}
            rules={{
                required: required === true,
                onChange: (newValue: any) => {
                    if (onValueChanged) {
                        onValueChanged(newValue.target.value, index);
                    }
                },
            }}
            render={({field: {onChange, onBlur, value, ref}}) => {
                return (
                    <>
                        <div className={title ? "form-group" : ""}>
                            {title && <label className={"form-label-sm"}>{title}</label>}
                            <NumberBox
                                value={value}
                                onValueChanged={(e) => onChange(e.value)}
                                width={width || undefined}
                                style={{border: showBorder === true ? "block" : "none"}}
                                showSpinButtons={true}
                                validationStatus={
                                    errors[fieldName]
                                        ? "invalid"
                                        : dirtyFields[fieldName]
                                            ? "valid"
                                            : "valid"
                                }
                                min={min}
                                max={max}
                            />

                            {isValid === true && (
                                <div className={"valid-feedback"}>{validationMessage}</div>
                            )}
                            {isValid === false && (
                                <div className={"invalid-feedback"}>{validationMessage}</div>
                            )}
                        </div>
                    </>
                );
            }}
        />
    );
};
